import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://dpdpa.blog';
const DEFAULT_IMAGE = 'https://customer-assets-4nw71qhi.emergentagent.net/job_48ccfe14-9a78-4511-9adb-e31d4f86bb3c/artifacts/qhjao7c6_ChatGPT%20Image%20Jul%2027%2C%202026%2C%2011_59_00%20PM.png';

export const SEO = ({ title, description, path = '', jsonLd }) => {
  const fullTitle = `${title} | DPDPA.blog`;
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:site_name" content="DPDPA.blog" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
